import '../../modules/mode-components';

import * as angular from 'angular';
import { map } from 'rxjs/operators';
import { NavMenuService } from '@mode/accounts/feature-header';

class NavFlyoutController {
  static $inject = ['NavMenuService'];

  private navOpen$ = this.navMenuService.navState();
  showLogoButton$ = this.navMenuService.navState().pipe(map((navOpen) => !navOpen));

  constructor(private navMenuService: NavMenuService) {}

  openNav(): void {
    this.navMenuService.open();
  }
}

const NavFlyoutComponent: angular.IComponentOptions = {
  bindings: {
    theme: '<',
  },
  controller: NavFlyoutController,
  controllerAs: 'ctrl',
  template: `
    <mode-nav-menu-container target="_self"></mode-nav-menu-container>
    <capra-tooltip tooltip-content="Open global navigation" tooltip-placement="bottom" tooltip-size="mini" tooltip-content-is-html="false">
      <capra-logo-button
        ng-if="ctrl.showLogoButton$ | async:this"
        ng-class="{ 'capra-logo-button-light': ctrl.theme === 'light' }"
        hamburger-state="collapsed"
        [theme]="ctrl.theme"
        (clicked)="ctrl.openNav()"
      ></capra-logo-button>
    </capra-tooltip>
  `,
};

angular.module('mode.components').component('navFlyout', NavFlyoutComponent);
